export const CREATIVE_TYPES = {
    DISPLAY: 'SPONSORED_DISPLAY_ITEMS_ONLY',
    NATIVE: 'SPONSORED_REGULAR_ITEMS_ONLY',
};

export const DISPLAY_AD_TYPE = {
    HOSTED: 'HOSTED',
    TAG: 'THIRD_PARTY_TAG',
    SOCIAL: 'HOSTED_SOCIAL',
};

export const DISPLAY_CREATIVE_TYPE_FILTER = {
    ALL: 'ALL',
    SOCIAL: 'SOCIAL',
};

export const FILE_SIZE_KILOBYTES = {
    VIDEO: 200_000,
    IMAGE: 2000,
    ARCHIVE: 2000,
};

export const SIZE_UNITS = {
    KB: 1000,
    MB: 1000000,
};
